import { type FC } from 'react'

import { type PimProductV11 } from '@redteclab/api/clients/bully'

import { ProductPicture } from '../../../product/components/ProductPicture'

import { ExperimentStickyBuyBoxCta } from './ExperimentStickyBuyBoxCta'
import { ExperimentStickyBuyBoxPriceInfo } from './ExperimentStickyBuyBoxPriceInfo'

export const ExperimentStickyBuyBoxV3: FC<{
  disableCta: boolean
  product: PimProductV11
}> = ({ disableCta, product }) => (
  <div className="fixed inset-x-0 bottom-0 z-10 hidden bg-light-primary-low p-3.5 pt-0 tablet:flex">
    <ul className="mx-auto flex w-[70rem] justify-between rounded-2xl p-5 pb-3 shadow-[0px_2px_5px_0px_#4444440F]">
      <li>
        <div className="flex items-center">
          <ProductPicture
            className="pr-2"
            imageProps={{
              alt: product.name,
              height: 56,
              src: product.images?.at(0),
              width: 56,
            }}
          />
          <div>
            <h2 className="text-m font-medium">{product.name}</h2>
          </div>
        </div>
      </li>
      <li className="grow">
        <ExperimentStickyBuyBoxPriceInfo />
      </li>
      <li>
        <ExperimentStickyBuyBoxCta disableCta={disableCta} />
      </li>
    </ul>
  </div>
)
